import Paper, { PaperProps } from "@mui/material/Paper";

export type { PaperProps };
export default Paper;
